import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay, tap } from 'rxjs/operators';
import { RequestCacheService } from '@core/api/data-services';

const DEFAULT_TTL = 300; // 5 minutes

const ENDPOINT_TTL_MAP: Record<string, number> = {
  shops: 600, // 10 minutes pour les shops
};

const ENDPOINTS_NOT_CACHABLE: string[] = [
  'tables',
  'positions',
  'orders',
  'service-dates',
];

@Injectable()
export class CacheInterceptor implements HttpInterceptor {
  constructor(private cache: RequestCacheService) {}

  intercept<T>(
    req: HttpRequest<T>,
    next: HttpHandler
  ): Observable<HttpEvent<T>> {
    if (req.method === 'GET') {
      const cachedResponse = this.cache.get(req);
      return cachedResponse
        ? of(cachedResponse).pipe(delay(0))
        : this.sendRequest(req, next);
    } else {
      return next.handle(req);
    }
  }

  sendRequest<T>(
    req: HttpRequest<T>,
    next: HttpHandler
  ): Observable<HttpEvent<T>> {
    if (ENDPOINTS_NOT_CACHABLE.some((path) => req.url.includes(`/${path}/`))) {
      return next.handle(req);
    }
    let TTL = DEFAULT_TTL;
    for (const [endpoint, cachedTtl] of Object.entries(ENDPOINT_TTL_MAP)) {
      if (req.url.includes(`/${endpoint}/`)) {
        TTL = cachedTtl;
        break;
      }
    }

    return next.handle(req).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          this.cache.set(req, event, TTL);
        }
      })
    );
  }
}
